import { EncryptStorage } from 'encrypt-storage';

export const encryptStorage = new EncryptStorage('@McQfTjWmZq4t7w!z%C4u7x!z%C*F-JaNdRgRgUkXp2r5u8x/A?D(G+KbPeShVmYq3t6v9y$B&E)H@cQfTjWmZq4t7w!z%ShVmYqUkXp2s5v8y/B?D(G+*F-JaNd', {
    encAlgorithm: 'Rabbit',
});